import React from "react";
import "./Elyon.scss";
import data from "./data.json";
import Card from "../../Component/Card/card";
import Elyon8images from "../../media/Eonna/Elyon/Elyon 8/Elyon 8";
import Elyon9images from "../../media/Eonna/Elyon/Elyon 9/Elyon 9";
const imageMap = {
  Elyon8images,
  Elyon9images,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="neweylon" className="produk1">
      <div className="cardhome-containercalamus">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
